import React from "react";
import "./Home.css";
import { FaPhoneAlt, FaMapMarkerAlt, FaEnvelope } from "react-icons/fa";
import { FaFacebookF, FaLinkedinIn, FaInstagram, FaYoutube } from "react-icons/fa";

function Footer(props) {
  return (
    <>
      {/*===== FOOTER AREA STARTS =======*/}
      <div
        className="vl-footer4-section-area"
        style={{
          backgroundImage: "url(assets/img/all-images/bg/BG-Orange-shade.png)",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="footer-description-area">
                <img src="assets/img/logo/Jeevandaan Logo.png" alt="" />
                <div className="space24" />
                <p>
                  Our mission is simple yet profound: to empower individuals and
                  families in our community to live healthier, happier lives.
                </p>
                {/* <div className="space28" /> */}
                {/* <div className="footer-form-area">
                  <form>
                    <input type="text" placeholder="Enter Your Email " />
                    <button type="submit" className="vl-btn4">
                      Subscribe Now{" "}
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 16.9371 5.06294 21.75 11 21.75C16.9371 21.75 21.75 16.9371 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM10 7C9.5955 7 9.2309 7.24364 9.0761 7.61732C8.92134 7.99099 9.0069 8.42111 9.2929 8.70711L10.5858 10L7.29289 13.2929C6.90237 13.6834 6.90237 14.3166 7.29289 14.7071C7.68342 15.0976 8.31658 15.0976 8.70711 14.7071L12 11.4142L13.2929 12.7071C13.5789 12.9931 14.009 13.0787 14.3827 12.9239C14.7564 12.7691 15 12.4045 15 12V8C15 7.44772 14.5523 7 14 7H10Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                    </button>
                  </form>
                </div> */}
              </div>
            </div>
            <div className="col-lg col-md-6">
              <div className="space30 d-md-none d-block" />
              <div className="footer-widget-area foot-padding1">
                <h3>Quick Links</h3>
                <ul>
                  <li className="footerli">
                    <a href="about.html">About Us</a>
                  </li>
                  <li className="footerli">
                    <a href="service.html">Our Services</a>
                  </li>
                  <li className="footerli">
                    <a href="team.html">Our Team</a>
                  </li>
                  <li className="footerli">
                    <a href="pricing.html">Our Blog</a>
                  </li>
                  <li className="footerli">
                    <a href="contact.html">Contact Us</a>
                  </li>
                  <li className="footerli">
                    <a href="/career">Career</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg col-md-6">
              <div className="space30 d-lg-none d-block" />
              <div className="footer-widget-area foot-padding2">
                <h3>Our Service</h3>
                <ul>
                  <li className="footerli">
                    <a href="#">Cardiology</a>
                  </li>
                  <li className="footerli">
                    <a href="#">Pediatrics</a>
                  </li>
                  <li className="footerli">
                    <a href="#">Gynaecology</a>
                  </li>
                  <li className="footerli">
                    <a href="#">Dermatology</a>
                  </li>
                  <li className="footerli">
                    <a href="#">Orthopedics</a>
                  </li>
                  <li className="footerli">
                    <a href="#">Psychology</a>
                  </li>
                  {/*  <li className="footerli">
                    <a href="#">Neurology</a>
                  </li> */}
                </ul>
              </div>
            </div>

            <div className="col-lg col-md-6">
              <div className="space30 d-lg-none d-block" />
              <div className="footer-widget-area">
                <h3>Contact Us</h3>

                <ul >
                  <li className="footerli">
                    <a href="tel:+919098852357">
                      <FaPhoneAlt className="footer-icon" />
                      +91 9098852357, 8269900698
                    </a>
                  </li>

                  <li className="footerli">
                    <a href="#">
                      <FaMapMarkerAlt className="footer-icon" />
                      Bhopal, Madhya Pradesh
                    </a>
                  </li>

                  <li className="footerli">
                    <a href="mailto:jeevandanhospital.hr@gmail.com">
                      <FaEnvelope className="footer-icon" />
                      jeevandanhospital.hr@gmail.com
                    </a>
                  </li>
                </ul>
                <div className="space20" />
                <ul className="social-links">
                  <li>
                    <a href="#">
                      <i className="fa-brands fa-facebook-f" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fa-brands fa-linkedin-in" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fa-brands fa-instagram" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fa-brands fa-youtube" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/*   <div className="space100" /> */}
          <div className="col-lg-12">
            <div className="copyright-area">
              <a href="#">Copyright ©2026 JEEVANDAAN MULTISPECILITY HOSPITAL. All Rights Reserved</a>
              <ul>
                <li>
                  <a href="#">Privacy Policy</a>
                  <span> | </span>
                </li>
                <li>
                  <a href="#">Terms Of Condition</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/*===== FOOTER AREA ENDS =======*/}
    </>
  );
}

export default Footer;
